import router from '@/router'
import sectionsService from '@/services/sections'

export default {
  namespaced: true,

  state: {
    sectionsTitle: '',
    sectionsText: '',
    sectionsList: [],
    currentSection: {},
    demosTitle: '',
    demosList: [],
  },

  mutations: {
    setSectionsTitle(state, title) {
      state.sectionsTitle = title
    },

    setSectionsText(state, text) {
      state.sectionsText = text
    },

    setSectionsList(state, list) {
      state.sectionsList = list
    },

    setCurrentSection(state, section) {
      state.currentSection = section
    },

    setDemosTitle(state, title) {
      state.demosTitle = title
    },

    setDemosList(state, list) {
      state.demosList = list
    },
  },

  actions: {
    findCurrentSection({ commit }, res) {
      let curr
      if (router.currentRoute.params.slug) {
        curr = res.find(
          section => section.slug === router.currentRoute.params.slug
        )
      } else {
        curr = res[0]
      }
      if (curr) {
        commit('setCurrentSection', curr)
      } else {
        commit('setError404', true, { root: true })
      }
    },

    fetchSectionsText({ commit }) {
      sectionsService.getSectionsText().then(res => {
        commit('setSectionsTitle', res.title)
        commit('setSectionsText', res.text)
      })
    },

    fetchSectionsList({ commit, dispatch }) {
      sectionsService.getSectionsList().then(res => {
        dispatch('findCurrentSection', res)
        commit('setSectionsList', res)
      })
    },

    fetchDemoSectionsText({ commit }) {
      sectionsService.getDemoSectionsText().then(res => {
        commit('setSectionsTitle', res.title)
        commit('setSectionsText', res.text)
      })
    },

    fetchDemoSectionsList({ commit, dispatch }) {
      sectionsService.getDemoSectionsList().then(res => {
        dispatch('findCurrentSection', res)
        commit('setSectionsList', res)
      })
    },

    fetchHomeDemoSectionsText({ commit }) {
      sectionsService.getDemoSectionsText().then(res => {
        commit('setDemosTitle', res.title)
      })
    },

    fetchHomeDemoSectionsList({ commit }) {
      return new Promise(resolve => {
        sectionsService.getDemoSectionsList().then(res => {
          commit('setDemosList', res)
          resolve(res)
        })
      })
    },
  },
}
